/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataPackageDownloadUrl
 */
export interface DataPackageDownloadUrl {
    /**
     * 
     * @type {string}
     * @memberof DataPackageDownloadUrl
     */
    downloadUrl: string;
}

/**
 * Check if a given object implements the DataPackageDownloadUrl interface.
 */
export function instanceOfDataPackageDownloadUrl(value: object): value is DataPackageDownloadUrl {
    if ((!('downloadUrl' in (value as Record<string, any>)) && !('download_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['downloadUrl'] === undefined && (value as Record<string, any>)['download_url'] === undefined)) return false;
    return true;
}

export function DataPackageDownloadUrlFromJSON(json: any): DataPackageDownloadUrl {
    return DataPackageDownloadUrlFromJSONTyped(json, false);
}

export function DataPackageDownloadUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPackageDownloadUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'downloadUrl': json['download_url'],
    };
}

export function DataPackageDownloadUrlToJSON(json: any): DataPackageDownloadUrl {
    return DataPackageDownloadUrlToJSONTyped(json, false);
}

export function DataPackageDownloadUrlToJSONTyped(value?: DataPackageDownloadUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'download_url': value['downloadUrl'],
    };
}

